// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"yF-z","smallCardRow":"zF-z","largeCardRow":"AF-z","productSearchRow":"BF-z","curatedRow":"CF-z"};